import { render, staticRenderFns } from "./SuggestInput.vue?vue&type=template&id=f36bac6e&scoped=true"
import script from "./SuggestInput.vue?vue&type=script&lang=js"
export * from "./SuggestInput.vue?vue&type=script&lang=js"
import style0 from "./SuggestInput.vue?vue&type=style&index=0&id=f36bac6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36bac6e",
  null
  
)

export default component.exports